import { useContext, useLayoutEffect, useState } from "react";
import CustomizerContext from "../../../../../_helper/Customizer";
import {
    Description,
    EndingDate,
    FiscalYear,
    Name,
    ShortName,
    StartingDate,
    Status,
} from "../../../../../Constant";
import { toast } from "react-toastify";
import { IFiscalYearPayload } from "../FiscalYear.types";
import useAuth from "../../../../../Hooks/useAuth";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";

export default function useFiscalYearController() {
    const axiosPrivate = useAxiosPrivate();
    const formTitle = FiscalYear;
    const { userOrganisationId }: any = useAuth();
    const { layoutURL } = useContext(CustomizerContext);
    const backBtn = `${process.env.PUBLIC_URL}/finance/settings/fiscal-year/${layoutURL}`;
    const [formFields, setFormFields] = useState<any[]>([
        {
            id: "name",
            name: "name",
            label: Name,
            type: "text",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "description",
            name: "description",
            label: Description,
            type: "textarea",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "is_active",
            name: "is_active",
            label: Status,
            type: "switch",
            value: "1",
            colSize: 6,
        },

        {
            id: "short_name",
            name: "short_name",
            label: ShortName,
            type: "text",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "start_date",
            name: "start_date",
            label: StartingDate,
            type: "date",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "end_date",
            name: "end_date",
            label: EndingDate,
            type: "date",
            value: "",
            required: true,
            colSize: 6,
        },

        {
            id: "is_current",
            name: "is_current",
            label: "Is Current",
            type: "switch",
            value: "1",
            colSize: 6,
        },
    ]);

    // ?? Call on every dependent change
    async function updateFields() {
        const updatedFields = [...formFields];
        setFormFields(updatedFields);
    }

    useLayoutEffect(() => {
        //?? Updates all fields once component is mounted
        updateFields();
    }, []);

    const onSubmit = async (data: IFiscalYearPayload) => {
        data.organisation_id = userOrganisationId;
        await axiosPrivate
            .post("/finances/fiscal-year", data)
            .then((_res) => {
                toast.success(`${_res.data.name} Created Successfully.`);
            })
            .catch((err) => {
                if (err.response && err.response.status === 422) {
                    toast.error("Validation Errors");
                } else if (err.response && err.response.status === 400) {
                    toast.error(err.response.data.detail);
                } else {
                    toast.error("Whoops! Something went wrong");
                }
                throw err;
            });
    };

    return { formTitle, formFields, backBtn, onSubmit };
}
